var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Wrapper_key, _Wrapper_uuid, _Wrapper_type, _Wrapper_stateChangeCallbacks;
import { uuidv4 } from '@embed/helpers';
/**
 *
 */
export class Wrapper {
    /**
     *
     */
    constructor(type, video) {
        _Wrapper_key.set(this, void 0);
        _Wrapper_uuid.set(this, void 0);
        _Wrapper_type.set(this, void 0);
        _Wrapper_stateChangeCallbacks.set(this, []
        /**
         *
         */
        );
        this.video = video;
        __classPrivateFieldSet(this, _Wrapper_type, type, "f");
        __classPrivateFieldSet(this, _Wrapper_uuid, uuidv4(), "f");
        __classPrivateFieldSet(this, _Wrapper_key, this.composeKey(video), "f");
    }
    // Implementation
    /**
     *
     */
    get key() {
        return __classPrivateFieldGet(this, _Wrapper_key, "f");
    }
    /**
     *
     */
    get uuid() {
        return __classPrivateFieldGet(this, _Wrapper_uuid, "f");
    }
    /**
     *
     */
    get type() {
        return __classPrivateFieldGet(this, _Wrapper_type, "f");
    }
    /**
     *
     */
    get maximumLiveStreamDuration() {
        return 60 * 60 * 5; // 18000 seconds or 5 hours
    }
    /**
     *
     */
    onStateChange(callback) {
        __classPrivateFieldGet(this, _Wrapper_stateChangeCallbacks, "f").push(callback);
        return () => {
            __classPrivateFieldSet(this, _Wrapper_stateChangeCallbacks, __classPrivateFieldGet(this, _Wrapper_stateChangeCallbacks, "f").filter((cb) => cb !== callback), "f");
        };
    }
    /**
     *
     */
    triggerStateChange(state) {
        __classPrivateFieldGet(this, _Wrapper_stateChangeCallbacks, "f").forEach((cb) => cb(state));
    }
    /**
     *
     */
    getBoundingClientRect() {
        return this.getContainer().getBoundingClientRect();
    }
    /**
     *
     */
    focus() {
        this.getContainer().focus();
    }
    /**
     *
     */
    getAttribute(qualifiedName) {
        return this.getContainer().getAttribute(qualifiedName);
    }
    /**
     *
     */
    setAttribute(qualifiedName, value) {
        return this.getContainer().setAttribute(qualifiedName, value);
    }
    /**
     *
     */
    removeAttribute(qualifiedName) {
        this.getContainer().removeAttribute(qualifiedName);
    }
    /**
     *
     */
    getRootNode(options) {
        return this.getContainer().getRootNode(options);
    }
    // HTMLElement getters and setters.
    /**
     *
     */
    get style() {
        return this.getContainer().style;
    }
}
_Wrapper_key = new WeakMap(), _Wrapper_uuid = new WeakMap(), _Wrapper_type = new WeakMap(), _Wrapper_stateChangeCallbacks = new WeakMap();
